import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IOcupacao } from "../../../models"

interface IOcupacaoState {
    ocupacoes: IOcupacao[]
    openOcupacaoDialog: boolean
    searchTerm: string
    categoria: keyof IOcupacao
}

const initialState: IOcupacaoState = {
    ocupacoes: [],
    openOcupacaoDialog: false,
    searchTerm: "",
    categoria: "cbosearch"
}

const ocupacaoSlice = createSlice({
    name: 'ocupacao',
    initialState,
    reducers: {
        setOcupacoesState(state, action: PayloadAction<IOcupacao[]>) {
            state.ocupacoes = action.payload
        },
        resetOcupacoesState(state) {
            state.ocupacoes = initialState.ocupacoes
        },
        setOpenOcupacaoDialogState(state, action: PayloadAction<boolean>) {
            state.openOcupacaoDialog = action.payload
        },
        setOcupacaoSearchTermState(state, action: PayloadAction<string>) {
            state.searchTerm = action.payload
        },
        resetOcupacaoSearchTermState(state) {
            state.searchTerm = initialState.searchTerm
        },
        setOcupacaoCategoriaState(state, action: PayloadAction<keyof IOcupacao>) {
            state.categoria = action.payload
        },
        resetOcupacaoCategoriaState(state) {
            state.categoria = initialState.categoria
        }
    }
})

export const {
    resetOcupacaoSearchTermState,
    resetOcupacoesState,
    setOcupacaoSearchTermState,
    setOcupacoesState,
    setOpenOcupacaoDialogState,
    resetOcupacaoCategoriaState,
    setOcupacaoCategoriaState
} = ocupacaoSlice.actions

export const ocupacaoReducer = ocupacaoSlice.reducer